const IMPORT_META_FIELDS = new Set(['is_new', 'matched_id']);

function isEmptyImportValue(value) {
  if (value === null || value === undefined || value === '') return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
}

function cleanImportedItem(item) {
  if (!item || typeof item !== 'object') return item;
  return Object.entries(item).reduce((clean, [key, value]) => {
    if (!IMPORT_META_FIELDS.has(key) && !isEmptyImportValue(value)) {
      clean[key] = value;
    }
    return clean;
  }, {});
}

function mergeMatchedItem(currentItem, importedItem) {
  const clean = cleanImportedItem(importedItem);
  return Object.entries(clean).reduce((merged, [key, value]) => {
    if (key !== 'id' && !isEmptyImportValue(value)) {
      merged[key] = value;
    }
    return merged;
  }, { ...(currentItem || {}) });
}

function isBlankItem(item) {
  if (!item || typeof item !== 'object') return true;
  const keys = ['name', 'cnpj', 'cpf', 'cei', 'address', 'contracted_role', 'registered_salary', 'hire_date', 'number'];
  return !keys.some(k => item[k] && String(item[k]).trim() !== '');
}

export function mergeImportedCollection(currentItems, importedItems) {
  const existing = Array.isArray(currentItems) ? currentItems : [];
  const incoming = Array.isArray(importedItems) ? importedItems : [];
  
  // Se o estado atual contém apenas 1 item inicial vazio (placeholder), descarta-o para substituição
  const cleanExisting = (existing.length === 1 && isBlankItem(existing[0])) ? [] : existing;
  const merged = cleanExisting.map(item => ({ ...item }));

  incoming.forEach(item => {
    const matchedId = item?.matched_id;
    const index = matchedId ? merged.findIndex(existingItem => existingItem?.id === matchedId) : -1;
    if (index >= 0) {
      merged[index] = mergeMatchedItem(merged[index], item);
    } else {
      if (merged.length === 1 && isBlankItem(merged[0])) {
        merged[0] = mergeMatchedItem(merged[0], item);
      } else {
        merged.push(cleanImportedItem(item));
      }
    }
  });

  // Remove qualquer item remanescente completamente em branco se houver itens válidos
  const nonBlank = merged.filter(item => !isBlankItem(item));
  return nonBlank.length > 0 ? nonBlank : (merged.length > 0 ? merged : [{}]);
}

// Listas são mescladas item a item; o resto é substituição direta. Telefone entra aqui para
// que um número importado não apague os que já estavam na ficha.
const MERGED_COLLECTIONS = new Set(['defendants', 'contracts', 'claimant_phones']);

export function mergeImportedField(formData, key, rawValue) {
  if (MERGED_COLLECTIONS.has(key)) {
    return mergeImportedCollection(formData?.[key], rawValue);
  }
  return rawValue;
}

export function mergeImportedFields(formData, selectedFields) {
  const merged = { ...(formData || {}) };
  selectedFields.forEach(item => {
    if (item.key && item.key.startsWith('pedidos.')) {
      const subKey = item.key.split('.')[1];
      if (!merged.pedidos) merged.pedidos = {};
      merged.pedidos = {
        ...merged.pedidos,
        [subKey]: {
          ...(merged.pedidos[subKey] || {}),
          ...item.rawValue
        }
      };
    } else {
      merged[item.key] = mergeImportedField(merged, item.key, item.rawValue);
    }
  });
  return merged;
}
